import {State} from "./state";
import {Department} from "@/models/Department";

const mutations = {
  SET_DEPARTMENTS: (state:State, Departments:Array<Department>) => {
    state.departments = Departments;
  },
  SET_SELECTED_DEPARTMENT: (state:State, department:Department) => {
    state.selectedDepartment =  department;
  },
  SET_LOADING_START: (state:State) => {
    state.isLoading = true;
  },
  SET_LOADING_FINISHED: (state:State) => {
    state.isLoading = false;
  },
  SET_SAVING_START: (state:State) => {
    state.isSaving = true;
  },
  SET_SAVING_FINISHED: (state:State) => {
    state.isSaving = false;
  },
  SHOW_FORM_MODAL: (state: State) => {
    state.modalFormVisible = true;
  },
  HIDE_FORM_MODAL: (state: State) => {
    state.modalFormVisible = false;
  },
};

export default mutations;